const DEMO_WSP_URL = encodeURI("https://wa.me/+5493534012614");

const WhatsappLink = ({ children }) => {
  return (
    <a
      href={DEMO_WSP_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      style={{ textDecoration: "none", marginTop: "auto" }}
    >
      {children}
    </a>
  );
};

export default WhatsappLink;
